import {
    SET_PROPERTY_ADDRESS,
    SET_PROPERTY_SEARCH_PENDING,
    SET_PROPERTY_SEARCH_FULFILLED,
    SET_SELECTED_PROPERTY,
} from '../../../constants/ActionTypes';
import propertyDetailsInitialState from './propertyDetailsInitialState';

function propertyDetailsReducer(state = propertyDetailsInitialState, action) {
    switch (action.type) {
    case SET_PROPERTY_ADDRESS: {
        return {
            ...state,
            searchedAddress: action.searchedAddress.target.value,
        };
    }
    case SET_PROPERTY_SEARCH_PENDING: {
        return {
            ...state,
            propertyList: [],
            selectedProperty: {},
            searchInProgress: true,
        };
    }
    case SET_PROPERTY_SEARCH_FULFILLED: {
        return {
            ...state,
            searchInProgress: false,
            propertyList: action.payload,
        };
    }
    case SET_SELECTED_PROPERTY: {
        return {
            ...state,
            selectedProperty: action.property,
        };
    }
    default:
        return state;
    }
}

export default propertyDetailsReducer;



// WEBPACK FOOTER //
// ./src/app/FormStepper/PropertyDetails/propertyDetailsReducer.js